module.exports = __webpack_public_path__ + "static/media/t-cwu.9cddafa5.svg";